module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920-a227f80bc8a819503bd2a95ef060be2a.webp";